import { createElement } from 'react';

import { DocSearchHit } from '../../../types';

function getPropertyByPath(object: Record<string, any>, path: string): any {
  const parts = path.split('.');

  return parts.reduce((prev, current) => {
    if (prev?.[current]) return prev[current];
    return null;
  }, object);
}

interface Props {
  item: DocSearchHit;
}

export const Snippet: React.FC<Props> = ({ item, ...rest }) => {
  return createElement('span', {
    ...rest,
    dangerouslySetInnerHTML: {
      __html:
        getPropertyByPath(item, `_snippetResult.content.value`) ||
        getPropertyByPath(item, 'content'),
    },
  });
};
